$(document).ready(function () {
  let shareData = {};

  let btn_arr = document.querySelectorAll(".share");
  btn_arr.forEach((el) => {
    el.addEventListener("click", async () => {
      let el_url = el.getAttribute("url").toString();
      shareData.url = el_url;

      try {
        await navigator.share(shareData);
      } catch {}
    });
  });
});
